import { Avatar, Indicator } from '@mantine/core'

export default function ProfileAvatar(props) {
    const { user, size = 30 } = props

    if (!user) {
        return null
    }

    const idleMs = Date.now() - (user?.lastActivity ?? 0)

    let indicatorColor = undefined
    if (idleMs < 300000) {
        indicatorColor = 'green'
    } else if (idleMs < 3600000) {
        indicatorColor = 'yellow'
    }

    const avatar = (
        <Avatar
            src={user?.avatar}
            name={user?.username || 'User'}
            size={size}
            radius="sm"
            color="initials"
        />
    )

    if (indicatorColor) {
        return (
            <Indicator
                color={indicatorColor}
                size={10}
                position="bottom-end"
                offset={3}
                withBorder
            >
                {avatar}
            </Indicator>
        )
    }

    return avatar
}
